<script lang="ts" setup>
import { TirPmButton, TirPmModal, TirPmButtonVariantEnum } from "tir-components";
import { useLoading, useModal } from "tir-pm-toolkit";
import { computed, PropType, ref } from "vue";
import { AdapterService } from "./adapter-service";
import { TimeTrackerRecordModel } from "../task-forms";

/**API сервис */
const apiService = new AdapterService();

/**пропсы */
const props = defineProps({
  /**Записи таймера */
  timerTrackerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**переносится ли задача */
  transferTask: {
    type: Boolean,
    default: false,
  },
});

/**События */
const emit = defineEmits<{
  /**Подтверждено удаление задачи */
  successRemove: [taskId: number];
}>();

/**Id задачи */
const taskId = ref<number>();
/**Имя задачи */
const taskName = ref<string>();
/**Произошла ошибка при удалении */
const removeError = ref(false);
/**Управление окном */
const { visible, open, close } = useModal();
/**Управление загрузкой */
const { isLoading, startLoading, stopLoading } = useLoading();

/**Заголовок окна */
const modalTitle = computed(() =>
  removeError.value ? "Невозможно удалить тикет" : "Удалить тикет",
);

/**Удалить задачу */
const removeTask = async () => {
  startLoading();

  const id = taskId.value;
  const name = taskName.value;

  if (!props.timerTrackerRecords.length || props.transferTask) {
    const response = await apiService.RemoveTask(id, name);

    if (response.IsSuccess && response.Value) {
      emit("successRemove", id);
      closeModal();
    }
  } else {
    setTimeout(() => (removeError.value = true));
  }

  stopLoading();
};
/**Открыть окно */
const openModal = (id: number, name: string) => {
  removeError.value = false;

  if (!id) return;

  taskId.value = id;
  taskName.value = name;
  open();
};
/**Закрыть окно */
const closeModal = () => {
  close();
  removeError.value = false;
  taskId.value = undefined;
  taskName.value = undefined;
  stopLoading();
};

/**Код для использования по ref */
defineExpose({ open: openModal });
</script>
<template>
  <TirPmModal
    :title="modalTitle"
    :is-visible="visible"
    :isWithBack="false"
    :isCloseOverlay="true"
    @close="closeModal"
  >
    <template #content>
      <div class="remove-task-modal__content">
        <template v-if="removeError">
          Одна из возможных причин:
          <ul class="remove-task-modal__ul">
            <li>Тикет связан с другой задачей/очередью</li>
            <li>Уже запускался таймер на выполнение</li>
          </ul>
        </template>
        <template v-else>
          Вы уверены что хотите удалить тикет:
          <span v-if="taskName" class="remove-task-modal__task-name" v-text="taskName" />?
        </template>
      </div>
    </template>
    <template #footer>
      <template v-if="removeError">
        <TirPmButton :variant="TirPmButtonVariantEnum.PrimaryState" @click="closeModal">
          Понятно
        </TirPmButton>
      </template>
      <template v-else>
        <TirPmButton
          :is-loading="isLoading"
          :variant="TirPmButtonVariantEnum.PrimaryState"
          @click="removeTask"
        >
          Удалить
        </TirPmButton>
        <TirPmButton :variant="TirPmButtonVariantEnum.SecondaryState" @click="closeModal">
          Отмена
        </TirPmButton>
      </template>
    </template>
  </TirPmModal>
</template>
<style lang="scss" scoped>
.remove-task-modal {
  &__content {
    margin: 0.75rem 0;
  }

  &__task-name {
    color: var(--text-info);
  }

  &__ul {
    margin: 0;
    padding-left: 24px;
  }
}
</style>
